import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { getRate } from './rate.interface';
import { AlertService } from 'src/app/services/alert.service';

@Component({
  selector: 'app-rate',
  templateUrl: './rate.component.html',
  styleUrls: ['./rate.component.scss']
})
export class RateComponent {
  constructor(private http: HttpClient,
    private alert: AlertService
  ) {
    this.getRate();
  }

  rateItems!: getRate
  rateItemsDefault!: getRate
  getRate() {
    this.http.get(`rate`).subscribe({
      next: (res: any) => {
        this.rateItems = res.data
        this.rateItemsDefault = Object.assign({}, res.data)
      }
    })
  }

  putRate() {
    this.alert.confirm('หากต้องการบันทึกค่านี้จะถูกนำไปใช้กับทั้งระบบ คุณต้องการแก้ไขหรือไม่').then(fm => {
      if (fm.isConfirmed) this.http.put(`rate/${this.rateItems.Rate_id}`, this.rateItems).subscribe({
        next: (res: any) => {
          this.alert.notify(res.message, 'success')
        },
        error: (err) => {
          this.alert.dialog(err.error.message)
        },
        complete: () => {
          this.getRate()
        }
      })
    })

  }

  resetValue() {
    this.rateItems = Object.assign({}, this.rateItemsDefault)
  }
}
